import React, { useRef, useState } from "react"
import styled from "styled-components"
import EmailEditor from "react-email-editor" // use react-email-editor instead
import { useParams } from 'react-router-dom';
import axios from "axios"  
import { useSelector  } from "react-redux";
import { selectLogInUsername } from "../../../../../common/authenticateDashboard/authSlice"
import { getDatabase, ref, get, set, push, update } from 'firebase/database';
import { nudgesCompany } from "../../../../../firebase";


const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
`

const Bar = styled.div`
  flex: 1;
  background-color: #172b4d;
  color: #000;
  padding: 15px;
  display: flex;
  justify-content: center;
  max-height: 50px;
  align-items: center;

  h1 {
    flex: 1;
    font-size: 18px;
    text-align: left;
  }

  button {
    padding: 10px 15px;
    margin-left: 10px;
    font-size: 14px;
    font-weight: bold;
    background-color: #000;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #333;
    }

    &:active {
      background-color: #555;
    }
  }
`;

const Constants = () => {

  const emailEditorRef = useRef(null)
  const [preview, setPreview] = useState(false)
  const [designName, setDesignName] = useState("")  
  const { endpoint1, endpoint2 } = useParams();
  const sessionUser = useSelector(selectLogInUsername)
  const user = sessionUser?.split('@')[0];


  const saveAndExportDesign = async () => {
    const unlayer = emailEditorRef.current?.editor;
  
    try {
      // Save design and export HTML concurrently using Promise.all
      const [design, { html }] = await Promise.all([
        new Promise((resolve, reject) => {
          unlayer?.saveDesign(design => {
            
            resolve(design);
          });
        }),
        new Promise((resolve, reject) => {
          unlayer?.exportHtml(data => {
            const { design, html } = data;
            
            resolve({ design, html });
          });
        })
      ]);
  
      const db = getDatabase(nudgesCompany); // Get a reference to the default database
      const newDataRef = ref(db, user); // Reference to a new child node
      const snapshot = await get(newDataRef ); // Fetch data from the database
      const getData = snapshot.val();
      const NudgesArray = Object.keys(getData)
      for(let i=0; i<NudgesArray.length; i++){
        console.log("data is getdata", getData[NudgesArray[i]])
        if(getData[NudgesArray[i]]["uniqueId"]==endpoint2){
          getData[NudgesArray[i]]["html"]=html
          getData[NudgesArray[i]]["design"]=design
        }
      }
      console.log("getData-->", getData)
      function replaceUndefinedWithNull(obj) {
        for (const key in obj) {
          if (typeof obj[key] === 'object' && obj[key] !== null) {
            replaceUndefinedWithNull(obj[key]);
          } else if (obj[key] === undefined) {
            obj[key] = null;
          }
        }
      }
      replaceUndefinedWithNull(getData);
  
      update(newDataRef , getData)
     
  
      // Function to replace undefined values with null
     
  
      // // Replace undefined values with null in newData
      // replaceUndefinedWithNull(newData);
  
      console.log("Data saved successfully in Firebase.");
      alert("Data saved successfully.");
    } catch (error) {
      console.error("Error:", error.message);
      alert("An error occurred while processing the data.");
    }
  };
  
  
  

  const togglePreview = () => {
    const unlayer = emailEditorRef.current?.editor

    if (preview) {
      unlayer?.hidePreview()
      setPreview(false)
    } else {
      unlayer?.showPreview("desktop")
      setPreview(true)
    }
  }

  const onDesignLoad = data => {
    console.log("onDesignLoad", data)
  }


  const onLoad = async (unlayer) => {
    console.log("onLoad", unlayer);
    
    try {
      const db = getDatabase(nudgesCompany); // Get a reference to the database
      const nudgesRef = ref(db, user); // Reference to the "predefinednudges" node
      console.log("user", user)
      const snapshot = await get(nudgesRef); // Fetch data from the database
  
      if (snapshot.exists()) {
        const data = snapshot.val(); // Retrieve the data from the snapshot
        console.log("Data fetched:", data);
        
        // Function to find the design by endpoint ID
        const findDesign = (obj) => {
          for (const key in obj) {
            if (typeof obj[key] === 'object' && obj[key] !== null) {
              const design = findDesign(obj[key]);
              if (design) return design;
            } else if (key === 'uniqueId' && obj[key] === endpoint2) {
              return obj.design;
            }
          }
          return null;
        };
  
        const design = findDesign(data); // Call the function to find the design
        console.log("Found design:", design);
  
        if (unlayer) {
          if (design) {
            try {
              await new Promise((resolve, reject) => {
                unlayer.loadDesign(design, (error) => {
                  if (error) {
                    reject(new Error(`Failed to load design: ${error.message}`));
                  } else {
                    resolve();
                  }
                });
              });
              console.log('Design loaded successfully');
            } catch (error) {
              console.error('Error loading design:', error.message);
              alert('Failed to load the design.');
            }
          } else {
            console.log('Design not found');
          }
        } else {
          console.error('Unlayer editor is not initialized.');
          alert('Unlayer editor is not initialized.');
        }
      } else {
        console.log('No data available');
      }
    } catch (error) {
      console.error('Error fetching data:', error.message);
    }
  };
  
  



  const onReady = unlayer => {
    console.log("onReady", unlayer)
  }

  return (
    <Container className="w-full h-auto">
      <Bar>
        <button onClick={togglePreview} class=" text-white text-sm px-4 py-1 bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg">
          {preview ? "Hide" : "Show"} Preview
        </button>
        <button onClick={saveAndExportDesign} class=" text-white text-sm px-4 py-1 bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg">Save Design</button>
      </Bar>

      <React.StrictMode>
        <EmailEditor ref={emailEditorRef} onLoad={onLoad} onReady={onReady}  displayMode="email"/>
      </React.StrictMode>
    </Container>
  )
}

export default Constants